import {
  getCore,
  postCore,
  putCore,
} from "../../../api/services/axiosCore.service";

import { User } from "../../../api/models";

/**
 * fetches a single user by ID and maps the result to an `User` instance.
 * @param {string} id - the ID of the user to retrieve.
 * @param {Object} [params] - optional parameters to include in the request.
 * @returns {Promise<Object>} A promise that contains the user data wrapped along with additional metadata.
 */
//TODO: agregar la creación de la instancia del user cuando eliminemos la store vieja.
//! No lo podemos hacer ahora porque esta respuesta lo usamos en la store vieja.
export const getUser = (id, params) => {
  return getCore(`/users/${id}`, params);
};

/**
 * Resends the confirmation email to the user.
 * If a token is provided, it will resend the email using the expired token.
 * @param {string} [expired_token] - The expired confirmation token to resend the email with (optional).
 * @returns {Promise<Object>} A promise resolving to the response of the resend request.
 */
export const resendConfirmationEmail = () => {
  return postCore(`/users/resend_confirmation`);
};

/**
 * Updates a user.
 * @param {string} id - The unique identifier of the user to be updated.
 * @param {Object} params - An object containing the updated user parameters.
 * @returns {Promise} A promise that resolves to the response of the update request.
 */
export const updateUser = (id, params) => {
  return putCore(`/users/${id}`, params).then((res) => {
    res.results = new User(res.results);
    return res;
  });
};

/**
 * Validates if the user's confirmation email is valid by fetching user details.
 * @returns {Promise<Object>} A promise resolving to the user's information.
 */
export const validateConfirmationEmail = () => {
  const params = {
    fields: "account.onboarding",
  };

  return getCore("/users/me", params).then((res) => {
    res.results = new User(res.results);
    return res;
  });
};
